module.exports = __webpack_public_path__ + "img/21-1.3b7d51cd.png";